import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";
import { isAdmin } from "./utils/adminAuth";
import LandingPage from "./components/LandingPage";
import SignUpPage from "./components/SignUpPage";
import LoginPage from "./components/LoginPage";
import DashboardPage from "./components/DashboardPage";
import AdminPage from "./components/AdminPage";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import CreateAdminPage from "./components/CreateAdminPage";
import Plans from "./pages/pricing/plans/Plans";
import About from "./pages/about/About";
import Terms from "./pages/legal/Terms";
import Licensing from "./pages/legal/Licensing";
import Privacy from "./pages/legal/Privacy";
import Cancellation from "./pages/legal/Cancellation";
import HelpCenter from "./pages/support/HelpCenter";
import Contact from "./pages/support/Contact";
import Part1_1 from "./components/questionCards/Part1/Part1_1";
import VocabularyStudy from "./components/questionCards/Part1/VocabularyStudy";
import ListeningSection from "./components/sections/ListeningSection";
import Part2_1 from "./components/questionCards/Part2/Part2_1";
import Part3_1 from "./components/questionCards/Part3/Part3_1";
import "./styles/table.css";
import { AuthProvider } from "./contexts/AuthContext";

// AdminRoute 컴포넌트 생성
const AdminRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user || !isAdmin(user)) {
    return <Navigate to="/" />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard/*" element={<DashboardPage />} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              }
            />
            <Route path="/create-admin" element={<CreateAdminPage />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/about" element={<About />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/licensing" element={<Licensing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cancellation" element={<Cancellation />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/part1/photo" element={<Part1_1 />} />
            <Route path="/part1/vocabulary" element={<VocabularyStudy />} />
            <Route path="/listening/*" element={<ListeningSection />} />
            <Route path="/listening/Part1/*" element={<Part1_1 />} />
            <Route path="/listening/Part2/*" element={<Part2_1 />} />
            <Route path="/listening/Part3/*" element={<Part3_1 />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
